<template>
  <div
    class="text-center text-green-900 bg-green-50 border border-green-600 rounded-4 px-7 py-2 mb-3"
  >
    <p class="flex justify-center lead">
      <img class="icon icon-md mr-2" :src="metricIcon" alt="" />
      {{ $t(`top_providers.label.${metric}`) }}
    </p>
    <p>{{ $t('top_providers.percent_searches', { percentage: percentageOfTotal }) }}</p>
  </div>
</template>

<script lang="ts" setup>
import { Metric } from './getTopProviders'
import BestScoreIcon from './images/BESTSCORE.svg'
import CheapestIcon from './images/CHEAPEST.svg'
import FastestIcon from './images/FASTEST.svg'

const props = defineProps<{
  metric: Metric
  percentage: number
}>()

const percentageOfTotal = computed(() => {
  return props.percentage.toFixed(0)
})

const metricIcon = computed(() => {
  switch (props.metric) {
    case Metric.BESTSCORE:
      return BestScoreIcon
    case Metric.FASTEST:
      return FastestIcon
    case Metric.CHEAPEST:
      return CheapestIcon
    default:
      return undefined
  }
})
</script>
